import Link from 'next/link'
import { useLocalePath } from '@/hooks'
import { useRouter } from 'next/router'

const BaseLink = ({
  href,
  children,
  isChangePath = true,
  locale,
  ...props
}) => {
  const router = useRouter()
  const { localePath } = useLocalePath()
  const updatedHref =
    typeof href === 'object'
      ? { ...href, pathname: localePath(href.pathname, isChangePath) }
      : localePath(href, isChangePath)
  let currentLocale = isChangePath ? false : locale ? locale : router.locale

  if (updatedHref.locale === false || locale === false) {
    currentLocale = false
  }

  return (
    <Link href={updatedHref} {...props} locale={currentLocale}>
      {children}
    </Link>
  )
}

export default BaseLink
